import { AvatarClient } from "@/components/AvatarClient";
import { ClientsDropdown } from "@/components/ClientsDropdown";
import RecentClients from "./RecentClients";
import ServiceJobForm from "./ServiceJobForm";
import AdvancedSettings from "./AdvancedSettings";

const ServiceJobFlow = ({
  emblaRef,
  slideInView,
  form,
  updateForm,
  handleCancel,
  handleSelectClient,
  errors,
  recentClients,
}) => {
  return (
    <div className="embla" ref={emblaRef}>
      <div className="embla__container">
        <div className="embla__slide" key={0}>
          {!form.client?._id ? (
            <div
              className="space-y-3"
              style={{
                display: slideInView === 0 ? "block" : "none",
              }}
            >
              <ClientsDropdown
                onClick={(e) => handleSelectClient(e)}
                onChange={(e) => handleSelectClient(e)}
                value={form.client}
                form={form}
                errors={errors}
                updateForm={updateForm}
              />
              {!form.newClient && (
                <RecentClients
                  clients={recentClients}
                  onSelectClient={handleSelectClient}
                />
              )}
            </div>
          ) : (
            <>
              <div className="mb-5">
                <AvatarClient
                  selected
                  onCancel={handleCancel}
                  {...form.client}
                />
              </div>
              <AdvancedSettings
                defaultOpen
                form={form}
                updateForm={updateForm}
              />
            </>
          )}
        </div>

        <div className="embla__slide" key={1}>
          <div
            style={{
              display: slideInView === 1 ? "block" : "none",
            }}
          >
            <div className="mb-5">
              <AvatarClient selected onCancel={handleCancel} {...form.client} />
              <ServiceJobForm form={form} updateForm={updateForm} />
            </div>
            <AdvancedSettings defaultOpen form={form} updateForm={updateForm} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceJobFlow;
